module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hby6x"))).then(() => parcelRequire('3a9aZ'));